module.exports = __webpack_public_path__ + "img/image-1.647efe42.jpeg";